import { QueueType } from '../models/enums/QueueType';
import { getQueueTypeHandler } from '../queueType/QueueTypeRegistry';

interface IQueueProcessingParamsProps {
    queueType: QueueType;
    onParamsChange?: (params: Record<string, unknown>) => void;
    initialValues?: Record<string, string>;
}

export function QueueProcessingParams({ queueType, onParamsChange, initialValues }: IQueueProcessingParamsProps) {
    return getQueueTypeHandler(queueType).renderParams(onParamsChange, initialValues);
}
